import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useRef, useContext } from 'react';
import { components } from 'react-select';
import { cx } from '@elliemae/ds-utilities/utils';
import { DropDownContext } from '../context.js';

function ValueContainer(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  var valueContainerRef = useRef(null);

  var _useContext = useContext(DropDownContext),
      changeMenuOpen = _useContext.changeMenuOpen,
      inputInFocus = _useContext.inputInFocus,
      value = _useContext.value,
      clearable = _useContext.clearable,
      removeDropdownIndicator = _useContext.removeDropdownIndicator;

  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "combobox-value-container",
    onClick: function onClick(e) {
      e.stopPropagation();
      changeMenuOpen(true);
    },
    ref: valueContainerRef,
    className: cx('combobox-v2-value-container', inputInFocus && 'in-focus', value && clearable && 'has-value', removeDropdownIndicator && 'dropdown-indicator-removed')
  }, /*#__PURE__*/React.createElement(components.ValueContainer, rest, children));
}

export default ValueContainer;
export { ValueContainer };
//# sourceMappingURL=ValueContainer.js.map
